var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPushRightArrow = function SvgPushRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.943 3.333 4 4.276l3.771 3.771L4 11.82l.943.942 4.714-4.713-4.714-4.715Zm5.952 9.334V3.333h1.334v9.334h-1.334Z",
    fill: "#B7B7B7"
  })));
};
export { SvgPushRightArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuOTQyNjcgMy4zMzMzN0w0IDQuMjc2MDRMNy43NzEzMyA4LjA0NzM3TDQgMTEuODE4N0w0Ljk0MjY3IDEyLjc2MTRMOS42NTY2NyA4LjA0ODA0TDQuOTQzMzMgMy4zMzMzN0g0Ljk0MjY3Wk0xMC44OTUzIDEyLjY2NjdWMy4zMzMzN0gxMi4yMjg3VjEyLjY2NjdIMTAuODk1M1oiIGZpbGw9IiNCN0I3QjciLz4KPC9zdmc+Cg==";